import Layout from '@/layout/paycools-index.vue'

export const checkoutRouter = {
  path: '/checkout',
  component: Layout,
  redirect: '/checkout',
  name: 'Checkout',
  meta: { title: 'checkout', icon: 'checkout' },
  alwaysShow: true,
  children: []
}
if (process.env.VUE_APP_PLATFORM === 'paycools') {
  const pList = [{
    path: 'orders',
    name: 'Orders',
    component: () => import('@/views/paycools/checkout/orders.vue'),
    meta: {
      title: 'orders', noCache: false,
      auth: ['AUTH_CODE_CHECKOUT_LIST']
    }
  }]
  checkoutRouter.children = checkoutRouter.children.concat(pList)
}
